import { useCallback, useRef } from 'react';

import { CreativeSlotTypes } from '../types/CreativeSlotTypes';

export interface SlideVisibilityConfig<T> {
    getBannerId: (banner: T) => string;
    getBannerTitle: (banner: T) => string;
    logViewAd: (params: {
        promotionName: string;
        index: number;
        creativeSlot: CreativeSlotTypes;
        carouselPosition: number;
    }) => void;
    logSlideView: (swiperName: string, slideName: string, position: number) => void;
    swiperName: string;
}

export const createSlideVisibilityTracking = <T>(config: SlideVisibilityConfig<T>) => {
    const { getBannerId, getBannerTitle, logViewAd, logSlideView, swiperName } = config;

    return (banners: T[], isCarouselVisible: boolean) => {
        const loggedSlides = useRef<Set<string>>(new Set());

        const logSlideIfNotLogged = useCallback(
            (index: number) => {
                const banner = banners[index];
                if (!banner || !isCarouselVisible) {
                    return;
                }

                const key = `${getBannerId(banner)}-${index}`;
                if (loggedSlides.current.has(key)) {
                    return;
                }

                loggedSlides.current.add(key);

                const title = getBannerTitle(banner);

                logViewAd({
                    promotionName: title,
                    index,
                    creativeSlot: CreativeSlotTypes.P1Hero,
                    carouselPosition: index + 1,
                });

                logSlideView(swiperName, title, index + 1);
            },
            [banners, isCarouselVisible]
        );

        const resetTracking = useCallback(() => {
            loggedSlides.current.clear();
        }, []);

        return { logSlideIfNotLogged, resetTracking };
    };
};
